import { mdiAlert, mdiCheck } from '@mdi/js';

export const NOTIFY_OPTIONS = {
  negative: {
    color: 'negative',
    icon: mdiAlert,
  },
  positive: {
    color: 'positive',
    icon: mdiCheck,
  },
};

export default NOTIFY_OPTIONS;
